<template>
  <div class="container">
    <vs-card class="mt-5">
      <template slot="header">
        <h5>Crear un trx manual</h5>
      </template>
      <vs-row class="ml-2">
        <vs-button @click="selectTrxType(trx)" v-for="trx in trxAvailable" class="ml-2"
          :color="(trxSelected !== null && trxSelected.trxType === trx.trxType) ? 'primary' : '#999'" size="small">
          {{ trx.trxType }}
        </vs-button>
      </vs-row>

      <vs-row class="mt-5">
        <div class="col col-lg-4">
          <vs-card v-if="trxSelected !== null">
            <template slot="header">
              <h5>Complete los campos para crear la transacción</h5>
            </template>
            <div class="p-4">
              <vs-input v-if="transactionType !== 'R' && transactionType !== 'I'" @blur="findProjectDetails" name="pid"
                v-validate="'required'" class="w-full" :label="`Indica el PID para obtener los datos del ${role}`"
                :danger="errors.has('pid')" :danger-text="errors.first('pid')" v-model="form.projectId"></vs-input>

              <vs-input @blur="findInvestor" v-if="transactionType === 'I'" v-validate="'required'" class="w-full"
                :label="`Ingrese el ID de inversionista`" name="iid" :danger="errors.has('iid')"
                :danger-text="errors.first('iid')" v-model="form.investorId"></vs-input>

              <vs-input v-if="transactionType !== 'R'" :disabled="true" class="mt-5 w-full"
                :label="`Nombre del ${role}`" v-model="name"></vs-input>

              <!--
                ocultar si es C210 y require banco
              -->
              <vs-textarea name="concept" v-validate="'required'" class="w-full mt-5" maxlength="50" label="Concepto"
                :danger="errors.has('concept')" :danger-text="errors.first('concept')"
                v-model="form.concept"></vs-textarea>

              <vs-input v-model="form.amount" class="w-full mt-5" name="amount" label="Monto"
                v-validate="'required|min_value:0'" :danger="errors.has('amount')"
                :danger-text="errors.first('amount')"></vs-input>

              <vs-button @click="previewTransaction" class="mt-5 float-right" :disabled="errors.count() > 0">
                Crear transacción
              </vs-button>
              <div class="clearfix"></div>
            </div>

          </vs-card>
          <div v-else>
            Seleccione el tipo de transacción a crear para continuar.
          </div>
        </div>
      </vs-row>
    </vs-card>

    <vs-popup :active.sync="showPreviewTransaction" title="Previsualización de operación">
      <template v-if="simulation !== null">
        <vs-table :data="[{}]">
          <vs-tr>
            <vs-td>Tipo de transacción</vs-td>
            <vs-td>{{ simulation.trx_type }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Concepto</vs-td>
            <vs-td>{{ simulation.concept }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Beneficiario</vs-td>
            <vs-td>{{ name }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Monto</vs-td>
            <vs-td>{{ simulation.amount | currency }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Saldo inicial</vs-td>
            <vs-td>{{ simulation.initial_balance | currency }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Saldo final</vs-td>
            <vs-td>{{ simulation.final_balance | currency }}</vs-td>
          </vs-tr>
        </vs-table>

        <!-- <v-error class="mt-3" v-if="simulation.final_balance < 0"
          error="El balance final no puede ser menor a cero"></v-error> -->

        <vs-button @click="requestTwoFactor" class="float-right mt-5">
          Confirmar
        </vs-button>

        <otp-two-factor-authenticator ref="requestTwoFactorOtp"></otp-two-factor-authenticator>
      </template>
    </vs-popup>
  </div>
</template>

<script>
import OtpTwoFactorAuthenticator from "@components/Otp/OtpTwoFactorAuthenticator.vue";
import { mapState } from "vuex";

export class TrxAvailable {
  constructor(trxType, concept) {
    this.trxType = trxType;
    this.concept = concept;
  }
}

export default {
  name: "manualTrx",
  components: { OtpTwoFactorAuthenticator },
  data: () => ({
    trxAvailable: [],
    trxSelected: null,
    showPreviewTransaction: false,
    requireBank: false,
    form: {
      amount: 0,
      clientName: null,
      supplierName: null,
      investorName: null,
      projectId: null,
      trxType: null,
      concept: null,
      clientId: null,
      bankAccountId: null,
      supplierId: null,
      investorId: null,
    },
    simulation: null
  }),
  computed: {
    ...mapState("auth", ["geolocation"]),
    transactionType() {
      if (this.trxSelected === null) {
        return null;
      }
      return this.trxSelected.trxType.charAt(0);
    },
    name() {
      let nameDict = {
        "C": this.form.clientName,
        "S": this.form.supplierName,
        "I": this.form.investorName,
      }
      return nameDict[this.transactionType] ?? "Desconocido";
    },
    role() {
      let roleDict = {
        "C": "solicitante",
        "S": "instalador",
        "I": "inversionista",
        "R": "RedGirasol"
      }
      return roleDict[this.transactionType] ?? "Desconocido";
    }
  },
  async mounted() {
    const { data } = await axios.get('/api/manual-transaction/trx-available')

    this.trxAvailable = data.map((transaction) => {
      return new TrxAvailable(transaction.trx_type, transaction.concept);
    });
  },
  methods: {
    async selectTrxType(trx) {
      this.trxSelected = trx
      this.form.trxType = trx.trxType;
      this.form.concept = trx.concept;
      setTimeout(() => {
        this.$validator.validate();
      }, 500)

      if (this.form.projectId !== null) {
        await this.findProjectDetails();
      }
    },
    async requestTwoFactor() {
      this.$refs.requestTwoFactorOtp.show()
      this.showPreviewTransaction = false;

      this.$refs.requestTwoFactorOtp.$once('confirm', async (value) => {
        if (value === true) {
          this.$refs.requestTwoFactorOtp.close()
          await this.confirmTransaction();
        }
      });
    },
    async previewTransaction() {
      this.showPreviewTransaction = true;
      // llamada axios post
      this.form.transactionType = this.transactionType;
      const { data } = await axios.post('/api/manual-transaction/simulate', {
        ...this.form,
        geolocation: this.geolocation
      })
      this.simulation = data;
    },
    async confirmTransaction() {
      this.$vs.loading();
      try {
        const { data } = await axios.post('/api/manual-transaction', {
          ...this.form,
          geolocation: this.geolocation
        })
        this.simulation = data;
        this.showPreviewTransaction = false;
        this.$vs.notify({
          title: '¡Listo!',
          text: 'La transacción se ha credo correctamente!',
          color: 'success',
          position: 'bottom-center',
          icon: 'access_time'
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async findProjectDetails() {
      this.$vs.loading();
      try {
        const { data } = await axios.get('/api/manual-transaction/project/' + this.form.projectId)

        this.requireBank = false;

        if (this.transactionType === "C") {
          this.form.clientId = data.client.id;
          this.form.clientName = data.client.full_name;

          if (data.client.bank_account !== null) {
            this.form.bankAccountId = data.client.bank_account.id;
            this.form.concept = this.form.concept
              .replace("%banks.name%", data.client.bank_account.bank.short_name)
              .replace('%bank_accounts.account%', data.client.bank_account.clabe);
            this.requireBank = true;
          }
        }

        if (this.transactionType === "S") {
          this.form.supplierId = data.supplier.id;
          this.form.supplierName = data.supplier.full_name;

          if (data.supplier.bank_account !== null) {
            this.form.bankAccountId = data.supplier.bank_account.id;
            this.form.concept = this.form.concept
              .replace("%banks.name%", data.supplier.bank_account.bank.short_name)
              .replace('%bank_accounts.account%', data.supplier.bank_account.clabe);

            this.requireBank = true;
          }
        }
      } catch (e) {
        this.$validator.errors.add({
          field: 'pid',
          msg: 'El proyecto no existe',
        })
      } finally {
        this.$vs.loading.close();
      }
    },
    async findInvestor() {
      this.$vs.loading();
      try {
        const { data } = await axios.get("/api/manual-transaction/investor/" + this.form.investorId)
        this.form.investorName = data.investor.full_name;
      } catch (e) {
        this.$vs.loading.close();
        this.$validator.errors.add({
          field: 'investorId',
          msg: 'El inversionista no existe',
        })
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped></style>
